'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadBaiduPopJS = function loadBaiduPopJS() {
    window._agl = [];
    window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);
    var agl = document.createElement('script');
    agl.type = 'text/javascript';
    agl.async = true;
    agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(agl, s);
};

var _doStatistics = function _doStatistics() {
    window._agl.push(['track', ['success', {
        t: 3
    }]]);
};

exports.default = {
    init: function init() {
        loadBaiduPopJS();
    },
    doStatistics: function doStatistics() {
        if (window._agl) {
            _doStatistics();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/baidu-popularize.js
// module id = F7lU
// module chunks = 11